export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3-shape/src/noop.js
// module id = 240
// module chunks = 0